export const tagManagerEvent = (event: string, button_name: string) => {
  //@ts-ignores
  window.dataLayer.push({
    event,
    button_name,
  });
};
